import Style from '../job-board-list/internal-job-list.module.css';
import JobBoardMenu from 'components/JobboradMenu';
import {Loading} from 'erp-react-components';
import {Trans, useTranslation} from 'react-i18next';
import MapIcon from 'images/svg/Icon feather-map-pin.svg';
import folderIcon from 'images/svg/Icon feather-folder.svg';
import PathIcon from 'images/svg/Path 5192.svg';
import flagIcon from 'images/svg/internalIcon.svg';
import Pagination from 'components/Pagination';
import {useJobboardAppliedList} from './useJobboardAppliedList';
import classNames from './appliedList.module.css';
import {useTableScroll} from 'components/customHooks/useTableBottomScroll';
import {useHistory} from 'react-router-dom';
import {Modal} from 'react-bootstrap';
import {useState} from 'react';
import moment from 'moment';
import {until} from 'helpers/helpers';
import reactQueryKeys from 'helpers/reactQueryKeys';
import {useQueryClient} from 'react-query';
import toastService from 'components/Toasts/toast-service';
import JobBoardMenuMobileView from 'components/JobboradMenu/job-board-menu-mobile-view';
import LeftIcon from 'images/svg/Icon feather-arrow-left.svg';
import {postAPI} from 'data.api';
import {employeeCancelAPplication} from 'api_urls';

const AppliedList = () => {
  const {t} = useTranslation();
  const history = useHistory();
  const queryClient = useQueryClient();
  const [isAPILoading, setisAPILoading] = useState(false);
  const [cancelApplication, setcancelApplication] = useState(false);
  const [comment, setcomment] = useState(null);
  const [currentRow, setcurrentRow] = useState(null);
  const {
    isLoading,
    data,
    jobboardAppliedList,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useJobboardAppliedList();

  useTableScroll(() => {
    fetchNextPage();
  }, '.fetch-applied-jobboard-list');

  const totalJobListCount =
    (data?.pages || [])[0]?.data?.pagination?.total || 0;

  async function handleRedirect(row, type) {
    if (type === 'view-application') {
      history.push({
        pathname: `/view/application/${row?.position_number}`,
        state: {
          ViewJob: row,
          postId: row?.position_number,
          created_at: row?.created_at,
        },
      });
    } else if (type === 'view-job') {
      history.push({
        pathname: `/internal/viewJob/${row?.position_number}`,
        state: {
          ViewJob: {
            ...row?.hiring_request,
            role: row?.job_role,
            created_at: row?.created_at,
          },
          postId: row?.position_number,
          apply: true,
        },
      });
    } else if (type === 'cancel-application') {
      history.push({
        pathname: `/internal/jobboard`,
      });
    }
  }

  async function onsubmit() {
    setisAPILoading(true);
    const [err, res] = await until(
      postAPI(
        {
          position_number: currentRow?.position_number,
          cancelled_message: comment || '',
        },
        employeeCancelAPplication,
      ),
    );
    setisAPILoading(false);
    if (err) {
      toastService.error({msg: err.message});
      return console.error(err);
    }
    if (res) {
      setcancelApplication(false);
      queryClient.invalidateQueries(reactQueryKeys.ALL_APPLIED_LIST);
      return toastService.success({msg: res.message});
    }
  }

  return (
    <>
      <div className={classNames['header-color']}>&nbsp;</div>
      <div className={classNames['internal-job-container']}>
        <div className={Style['internal-job-sub-container']}>
          <div className={Style['internal-job-info-container']}>
            <div className={Style['internal-job-info']}>
              <JobBoardMenu active={'application'} />
            </div>
          </div>{' '}
          {!isLoading && jobboardAppliedList?.length ? (
            <>
              <div className={Style['job-board-list-container']}>
                <div className={classNames['back-arrow-container']}>
                  <div>
                    {' '}
                    <img
                      src={LeftIcon}
                      onClick={() =>
                        history.push({
                          pathname: '/internal/jobboard',
                        })
                      }
                    ></img>
                  </div>
                  <div className={Style['pagination-m']}>
                    {isFetchingNextPage ? <Loading /> : <></>}
                    <Pagination
                      loadNext={isFetchingNextPage}
                      displayCount={jobboardAppliedList?.length}
                      totalCount={totalJobListCount}
                    />
                  </div>
                </div>
                <div
                  className={`awl-custom-scroll fetch-applied-jobboard-list ${classNames['internal-job-list']}`}
                >
                  {(jobboardAppliedList || []).map((j) => {
                    let branch_ = [];
                    (j?.hiring_request?.job_posted_to || []).forEach((j) => {
                      branch_ = [...branch_, ...j?.branches];
                    });
                    branch_ = (branch_ || []).filter(
                      (arr, index, self) =>
                        index === self.findIndex((t) => t.id === arr.id),
                    );
                    return (
                      <div
                        className={`mb-2 ${Style['how-to-apply-title-text']}`}
                        key={j?.position_number}
                      >
                        {(j?.hiring_request?.job_posted_to || []).some((p) => {
                          return p?.job_post_type === 'internal';
                        }) ? (
                          <div className={classNames['header-info']}>
                            <div className={Style['flag-icon']}>
                              <img src={flagIcon} />
                            </div>
                            {!j?.is_cancelled ? (
                              <div
                                className={classNames['applied-text-date-m']}
                              >
                                <Trans
                                  i18nKey={'Applications_AppliedStatus'}
                                  t={t}
                                  defaults={'<3>Applied on</3> <4>{{date}}</4>'}
                                  components={{
                                    1: <strong />,
                                    2: <br />,
                                    3: (
                                      <div
                                        className={classNames['applied-text']}
                                      ></div>
                                    ),
                                    4: (
                                      <div
                                        className={classNames['applied-date']}
                                      ></div>
                                    ),
                                  }}
                                  values={{
                                    date: moment(j?.created_at).format(
                                      'D MMM YYYY, h:mm A',
                                    ),
                                  }}
                                />{' '}
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        ) : (
                          <div>
                            <div className={Style['flag-icon']}>
                              &nbsp;&nbsp;&nbsp;&nbsp;
                            </div>
                          </div>
                        )}

                        <div className="ml-4">
                          <div className={` ${Style['view-job-details']}`}>
                            <div>
                              <strong
                                className={`mr-2 ${Style['heading-font']}`}
                              >
                                <button
                                  className={classNames['position-number']}
                                  onClick={() =>
                                    history.push(
                                      `/viewJob/${j?.position_number}`,
                                    )
                                  }
                                >
                                  <strong>
                                    {j?.position_number || ''} -{' '}
                                    {` ${j?.job_role}`}
                                  </strong>
                                </button>
                              </strong>
                              <div
                                className={classNames['view-job-others-m']}
                              ></div>
                              <span>
                                <img
                                  className={`mr-1 ${Style['view-job-map-icon']}`}
                                  src={MapIcon}
                                />
                              </span>
                              <span className={Style['default-text']}>
                                {(branch_ || [])
                                  .map((b) => {
                                    return b?.name;
                                  })
                                  ?.join(', ')}
                              </span>
                            </div>
                            {!j?.is_cancelled ? (
                              <div className={classNames['applied-text-date']}>
                                <Trans
                                  i18nKey={'Applications_AppliedStatus'}
                                  t={t}
                                  defaults={'<3>Applied on</3> <4>{{date}}</4>'}
                                  components={{
                                    1: <strong />,
                                    2: <br />,
                                    3: (
                                      <div
                                        className={classNames['applied-text']}
                                      ></div>
                                    ),
                                    4: (
                                      <div
                                        className={classNames['applied-date']}
                                      ></div>
                                    ),
                                  }}
                                  values={{
                                    date: moment(j?.created_at).format(
                                      'D MMM YYYY, h:mm A',
                                    ),
                                  }}
                                />{' '}
                              </div>
                            ) : (
                              <div>
                                <div
                                  className={
                                    classNames['applied-text-date'] +
                                    ' ' +
                                    classNames['cancelled-text']
                                  }
                                >
                                  {t('View_application_Cancelled on')}
                                </div>
                                <div className={classNames['applied-date']}>
                                  {j?.cancelled_details?.created_at
                                    ? moment(
                                        j?.cancelled_details?.created_at,
                                      ).format('D MMM YYYY, h:mm A')
                                    : ''}
                                </div>
                              </div>
                            )}
                          </div>
                          <div className={classNames['employment-type']}>
                            <img
                              className={Style['view-job-dept']}
                              src={folderIcon}
                            ></img>
                            <span className="mr-2">
                              {j?.hiring_request?.department?.name || ''} |{' '}
                              {j?.hiring_request?.contract_type || ''}
                            </span>
                            {j?.hiring_request?.is_remote_job == 2 ? (
                              <span className={Style['hybird-status']}>
                                {t('JOB_BOARD_Hybrid')}
                              </span>
                            ) : j?.hiring_request?.is_remote_job == 1 ? (
                              <span className={Style['remort-status']}>
                                {t('JOB_BOARD_Remote')}
                              </span>
                            ) : (
                              <span className={Style['onsite-status']}>
                                {t('JOB_BOARD_Studio')}
                              </span>
                            )}
                          </div>
                          <div className={classNames['ex-btns']}>
                            {(j?.hiring_request?.experience_from &&
                              j?.hiring_request?.experience_to) ||
                            j?.hiring_request?.experience_to ? (
                              <>
                                <div
                                  className={
                                    'd-flex' +
                                    ' ' +
                                    classNames['experience-text-color']
                                  }
                                >
                                  <span>
                                    <img
                                      className={Style['view-job-ex-sub']}
                                      src={PathIcon}
                                    ></img>
                                  </span>
                                  {`${
                                    j?.hiring_request?.experience_from || 0
                                  } - ${j?.hiring_request?.experience_to}`}{' '}
                                  {t('Search_Job_Years Experience')}
                                </div>
                              </>
                            ) : (
                              <div
                                className={
                                  'd-flex' +
                                  ' ' +
                                  classNames['experience-text-color']
                                }
                              >
                                <span>
                                  <img
                                    className={Style['view-job-ex-sub']}
                                    src={PathIcon}
                                  ></img>
                                </span>
                                {t('JOB_BOARD_Fresher')}
                              </div>
                            )}
                            <div className={classNames['action-btns']}>
                              <button
                                className={`mr-2 ${classNames['view-btn']}`}
                                onClick={() =>
                                  handleRedirect(j, 'view-application')
                                }
                              >
                                {t('Applications_View Application')}
                              </button>
                              <button
                                className={`mr-2 ${Style['view-btn']}`}
                                onClick={() => handleRedirect(j, 'view-job')}
                              >
                                {t('Search_Job_View Job')}
                              </button>
                              {!j?.is_cancelled ? (
                                <button
                                  className={classNames['cancel-btn']}
                                  disabled={j?.is_cancelled}
                                  onClick={() => {
                                    setcurrentRow(j);
                                    setcomment(null);
                                    setcancelApplication(true);
                                  }}
                                >
                                  {t('Applications_Cancel Application')}
                                </button>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className={Style['pagination']}>
                  {isFetchingNextPage ? <Loading /> : <></>}
                  <Pagination
                    loadNext={isFetchingNextPage}
                    displayCount={jobboardAppliedList?.length}
                    totalCount={totalJobListCount}
                  />
                </div>
              </div>
            </>
          ) : !isLoading && !jobboardAppliedList?.length ? (
            <div className={classNames['records-not-found']}>
              {t('Records Not Found')}
            </div>
          ) : (
            <Loading />
          )}
        </div>
      </div>
      <div className={Style['menu-item-mv']}>
        <JobBoardMenuMobileView active={'application'} />
      </div>
      <Modal
        className="awl-modal"
        show={cancelApplication}
        onHide={() => {
          setcancelApplication(false);
        }}
        size={'md' as any}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> {t('Applications_Cancel Application')} </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 pr-1 awl-custom-scroll">
          <div className={classNames['cancel-modal']}>
            {t(
              'Cancel_Application_Are you sure you want to cancel the application?',
            )}
          </div>
          <div className="mb-2">
            <textarea
              className="awl-form-control"
              placeholder={t('Enter')}
              name={'comment'}
              value={comment}
              onChange={(e) => {
                setcomment(e.target.value);
              }}
            />
          </div>
          <div className={classNames['cancel-modal-btns']}>
            <button
              className={`mr-2 ${Style['view-btn']}`}
              onClick={() => setcancelApplication(false)}
            >
              {t('No')}
            </button>
            <button
              className={Style['apply-btn']}
              disabled={isAPILoading}
              onClick={() => onsubmit()}
            >
              {t('Yes')}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AppliedList;
